import React from 'react';
import { CheckIcon, LightbulbIcon } from 'lucide-react';
import { childGets, projects } from '../data/landing';
import { CTAButton } from './CTAButton';
const levelTone: Record<string, string> = {
  Easy: 'bg-mint text-teal',
  Medium: 'bg-butter text-ink',
  Challenging: 'bg-blush text-berry'
};
export function ProjectsShowcase() {
  const loop = [...projects, ...projects, ...projects, ...projects];
  return <section className="pegboard w-full overflow-hidden py-20 md:py-28" aria-labelledby="projects-title" data-id="element-215" data-mp="2f4qrst6cdqyq">
      <div className="mx-auto max-w-3xl px-5 text-center" data-id="element-216" data-mp="2j3zjztlqhgs6">
        <span className="inline-flex items-center gap-2 rounded-full bg-white px-4 py-1.5 font-display text-sm font-semibold text-teal shadow-soft md:text-base" data-id="element-217" data-mp="25e4fp8xu3iks">
          <LightbulbIcon className="h-4 w-4" aria-hidden data-id="element-218" data-mp="2ab4q1w1pv7hp" />
          Hands-on Projects: Limitless Creativity
        </span>
        <h2 id="projects-title" className="mt-5 font-display text-3xl font-bold leading-tight text-ink md:text-5xl" data-id="element-219" data-mp="32t9y535tzto6">
          What your child gets: <span className="text-teal" data-id="element-220" data-mp="2akhfvbsxxb7h">100+ Projects That Actually Work</span>
        </h2>
        <p className="mt-4 text-lg font-semibold text-inkSoft" data-id="element-221" data-mp="26inhja67wjah">
          Every project is tested, illustrated and written in simple language your child can follow — or do together with you.
        </p>
      </div>

      <div className="relative mt-12" aria-label="Project examples" data-id="element-222" data-mp="2fhhifcqkzvtu">
        <div className="animate-marqueeFast flex w-max gap-5 px-2" data-id="element-223" data-mp="2u76sjxgnja69">
          {loop.map((p, i) => <figure key={`${p.name}-${i}`} aria-hidden={i >= projects.length} className="relative h-80 w-60 shrink-0 overflow-hidden rounded-3xl bg-white shadow-soft md:h-96 md:w-72" data-id="element-224" data-mp="2p8vetbn8kfir" data-mpi={i}>
              <img src={p.image} alt={i < projects.length ? p.name : ''} className="absolute inset-0 h-full w-full object-cover object-top" data-id="element-225" data-mp="2y9jsg58pwdv4" />
              <figcaption className="absolute inset-x-3 bottom-3 flex items-center justify-between gap-2 rounded-2xl bg-white/95 px-3 py-2" data-id="element-226" data-mp="13v0tudraquid">
                <span className="truncate font-display text-sm font-semibold text-ink" data-id="element-227" data-mp="33yk3uw4nafal">{p.name}</span>
                <span className={`shrink-0 rounded-full px-2.5 py-0.5 text-xs font-extrabold ${levelTone[p.level]}`} data-id="element-228" data-mp="38x4sdyajbaj7">{p.level}</span>
              </figcaption>
            </figure>)}
        </div>
      </div>

      <div className="mx-auto mt-14 max-w-5xl px-5 text-center" data-id="element-229" data-mp="3hycqogd1wbda">
        <ul className="grid gap-4 text-left sm:grid-cols-2 lg:grid-cols-3" data-id="element-230" data-mp="3mwwd0hvk3p66">
          {childGets.map(item => <li key={item} className="flex items-start gap-3 rounded-2xl bg-white p-5 text-base font-bold text-ink shadow-soft" data-id="element-231" data-mp="3rtwj2sseorxa">
              <span className="flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-mint text-teal" data-id="element-232" data-mp="imqkeb6sr81">
                <CheckIcon className="h-4 w-4" strokeWidth={3} aria-hidden data-id="element-233" data-mp="9h86s2t6ru5n" />
              </span>
              {item}
            </li>)}
        </ul>
        <CTAButton size="md" className="mt-10" data-id="element-234" data-mp="egujmb53r8dx">Get the full library</CTAButton>
      </div>
    </section>;
}